import httpClient from '@src/services/http.service'

const state = {
  areas: [],
}

const getters = {
  mainAreas: state => state.areas.slice(0, 8),
  areas: state => state.areas,
  nextDistrict: state => district => {
    const areaOrderingNum = state.areas.indexOf(district)
    if (district._id !== state.areas[state.areas.length - 1]._id) {
      return state.areas[areaOrderingNum + 1].slug
    }
  },

  previousDistrict: state => district => {
    const areaOrderingNum = state.areas.indexOf(district)
    if (areaOrderingNum) {
      return state.areas[areaOrderingNum - 1].slug
    }
  }
}

const mutations = {
  SET_AREAS: (state, areas) => {
    state.areas = areas.filter(area => area.status === 'published')
  },
}

const actions = {
  fetchAreas: ({ commit }) => {
    httpClient.get('area')
    .then(response => {
      const sortedAreas = response.data.sort((first, second) => {
        return parseInt(first.order) - parseInt(second.order)
      })
      commit('SET_AREAS', sortedAreas)
    })
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
